import xmlToJs from 'xml2js';

/**
 * Transfer xml data into json data
 *
 * @param {string} xmlData - The string of xml that needs to be transformed
 * @returns {object} - The Json object xml transformed to
 */
export const xmlToJson = (xmlData) => {
  let jsonValue = '';
  xmlToJs.parseString(xmlData, function (err, result) {
    jsonValue = result;
  });
  return jsonValue;
};

/**
 * Map the instrumentType array returned by IPSI to a default value of ["UU"] if the input is null, undefined, blank string or an empty array
 * @param {string|null|undefined|Array} instrumentType instrumentType returned by IPSI
 * @returns {Array} - The instrumentType array or ["UU"] if the input is null, undefined, blank string or empty array
 */
export const mapIpsiInstrumentTypeArray = (instrumentType) => {
  if (!instrumentType || instrumentType.length === 0) {
    return ['UU'];
  }
  return instrumentType;
};
